const selfTrainingV2 = {
  back: "Back",
  import: "Import",
  import_general_project: "Import General Project",
  import_my_project: "Import My Project",
  general_projects: "General Projects",
  my_projects: "My Projects",
  legacy_projects: "Legacy Projects",
  import_legacy_projects: "Import Legacy Projects",
  import_legacy_projects_descripton:
    "It will import Self Training V1 Models. Do you wish to continue",
  successfully_imported: "Successfully Imported the Legacy Projects",
  no_legacy_models_to_import: "No Legacy Models to Import",
  general_project: "General Project",
  source_project: "Source Project",
  select_general_project: "Select General Project",
  select_source_project: "Select source project",
  general_project_required: "General project is required",
  source_project_required: "Source project is required",
  project_imported_success: "Project imported successfully",
  training_history: "Training History",
  no_training_history: "No training history yet",
  source_project_not_trained: "Source project is not trained",
  started_by: "Started by",
  started_on: "Started on",
  completed_on: "Completed on",
  model_id: "Model",
  documents_label: "Documents",
  projects_heading: "Projects",
  something_went_wrong: "Something went wrong. Please try again.",
  permission_not_granted: "You do not have permission to perform this action.",
  no_permission: "You do not have permission to view this page.",
  project_training_in_progress: "Project training is already in progress.",
  project_analyzing_in_progress: "Project analysis is already in progress.",
  project_min_documents_required:
    "A minimum 5 number of documents is required to start training.",
  history_error: "Error",
  delete_field_title: "Delete this field?",
  delete_field_message: "Are you sure you want to delete this field?",
  delete_document_title: "Delete this document?",
  delete_document_message:
    "Are you sure you want to delete this document? This cannot be undone.",
  document_deleted_success: "Document deleted successfully",
  yes: "Yes",
  no: "No",
  reviewToolbar: {
    save: "Save",
    download_document: "Download document",
    previous_page: "Previous page",
    next_page: "Next page",
    zoomin: "Zoom in",
    zoomout: "Zoom out",
    deselect_multiple: "Clear field selection",
    select_feilds_one_by_one: "Click to select fields one by one",
    drage_select_multiple: "Drag to select multiple fields",
    bulk_select_items: "Bulk select Table Lines",
    Rotate_document: "Rotate document",
    done: "Done",
    hide_info: "Hide Info",
    show_info: "Show Info",
  },
  documents: {
    title: "Documents",
    upload: "Upload Document",
    single_upload: "Single Upload",
    bulk_upload: "Bulk Upload",
    bulk_upload_success: "Documents uploaded successfully",
    bulk_max_reached: "Maximum of 10 files reached",
    drop_files_here: "Drop the files here...",
    drag_or_click: "Drag & drop files here, or click to select",
    max_files: "Maximum {max} files",
    selected_files: "Selected Files",
    slots_remaining: "more allowed",
    select: "Select Document",
    select_to_preview: "Select a document to preview",
    uploaded_count: "uploaded",
    analyzed_count: "analyzed",
    no_documents: "No documents uploaded yet",
    upload_hint: "Upload at least 5 documents to enable analysis",
    min_docs_required: "Upload at least 5 documents before analyzing",
    actions: "Actions",
    edit_project: "Edit Project",
    analyze_btn: "Analyze",
    analyze_started: "Analysis started successfully",
    analyze_in_progress: "Project analysis is already in progress",
    already_analyzed: "Documents are already analyzed",
    analyze_first: "Analyze documents before reviewing",
    training_btn: "Start Training",
    training_started: "Training started successfully",
    training_hint: "Analyze and review documents first before training",
    document_not_analyzed:
      "This document has not been analyzed yet. Run Analyze first.",
    training_completed_at: `Training completed on`,
    current_model: `Current Model`,
    no_documents_found: "No documents found",
    no_model_yet: "No trained model yet",
    updated_by: "Updated By",
    on: "on",
    ignore_duplicate: "Ignore duplicate",
    reason_to_ignore_duplicate: "Reason to ignore duplicate",
    reason_to_ignore_duplicate_required: "Reason to ignore duplicate is required",
  },
  review: {
    save: "Save",
    saving: "Saving...",
    no_fields: "No fields extracted for this document",
    analyze_first:
      "Document not analyzed. Please run Analyze on this project first.",
    no_page_image: "No page image available",
    doc_type: "Filter mandatory fields by document class",
    doc_type_placeholder: "Select document type",
    general: "General",
    row: "Row",
    table: "Table",
    label: "Label",
    value: "Value",
    row_number: "Row number",
    row_number_start: "Row number start (1 - {{itemsLen}})",
    row_number_end: "Row number end (1 - {{itemsLen}})",
    field_required: "Field is required",
    itemindex_required: "Row number is required",
    item_required: "Field is required",
    remove: "Remove",
    insert_as_new_row: "Insert as new row",
    bulk_assign: "Bulk Assign",
    selected_text: "Selected text",
    assign_field: "Assign Field",
    assign_to_field: "Assign to field",
    table_name: "Table",
    item_field: "Field",
    row_from: "Row from",
    row_to: "Row to",
    auto_fill: "Auto-filled",
    areas_selected: "item(s)",
    rows: "row(s)",
    field_name: "Field name",
    required: "Required",
    no_rows: "No rows",
    empty_row: "Empty row",
    line: "Line",
    action: "Action",
    add_row: "Add Row",
    insert_new_rows: "Insert new row(s)",
    row_number_optional: "Row number (Optional)",
    row_count_optional: "Row count (Optional)",
    insert_at_row: "Insert at row (1 to {{max}})",
    insert: "Insert",
    delete_row_title: "Delete this row?",
    delete_row_message: "Are you sure you want to delete this row?",
    cancel: "Cancel",
    view_table: "View table",
  },
  status: {
    Draft: "Draft",
    Pending: "Pending",
    Analyzing: "Analyzing",
    Analyzed: "Analyzed",
    Training: "Training",
    Trained: "Trained",
    Failed: "Failed",
  },
  projects: {
    title: "Self Training V2",
    add_project: "Add Project",
    edit_project: "Edit Project",
    delete_project: "Delete Project",
    project_name: "Project Name",
    description: "Description",
    tags: "Tags",
    import_general_project: "Import General Project",
    select_general_project: "Select General Project",
    general_project: "General Project",
    project_created_success: "Project created successfully",
    project_updated_success: "Project updated successfully",
    project_deleted_success: "Project deleted successfully",
    project_imported_success: "Project imported successfully",
    no_projects_found: "No projects found",
    confirm_delete: "Are you sure you want to delete this project?",
    created_on: "Created on",
    updated_on: "Updated on",
    status: "Status",
    successfully_deleted: "Successfully deleted",
    training_status: {
      idle: "Idle",
      start_training: "Start Training",
      training: "Training",
      trained: "Trained",
      failed: "Failed",
      start_analyzing: "Start Analyzing",
      analyzing: "Analyzing",
      analyzed: "Analyzed",
    },
  },
};

export default selfTrainingV2;
